<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">{{'pageHeader.workingDays' | translate}}</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm"><img [src]="logo" class="img-icon" />&nbsp;&nbsp;{{'pageHeader.workingDays' | translate}}</h1>
  </div>
</div>

<div class="wd-effective-note">
  <i class="fa fa-info-circle"></i>
  <span>
    <b>Changes take effect from today</b> and apply to the rest of this month and all coming months.
    Earlier days &mdash; including the days of this month before today &mdash; and all previous months keep the working days that applied then,
    so their reports are not affected. Use <b>History by month</b> below to review any past month.
  </span>
</div>

<div class="panel panel-success widget-support-tickets">
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">
          <div class="bu-filter">
            <label class="control-label">Business Unit</label>
            <span class="ui-fluid">
              <p-dropdown [options]="businessUnits"
                          styleClass="wid100"
                          placeholder="All business units (company default)"
                          emptyFilterMessage="No results found"
                          [showClear]="true"
                          [(ngModel)]="selectedBusinessUnit"
                          [filter]="true" optionLabel="name"></p-dropdown>
            </span>
          </div>

          <working-days-editor [businessUnitId]="businessUnitId"
                               [canManage]="canManage"
                               (changed)="onChanged($event)"></working-days-editor>
        </div>
      </div>
    </div>
  </div>
</div>
